export const getProgramParamsFilter = (params) => {
  const searchParams = new URLSearchParams(window.location.search);
  const programParam = searchParams.get('program') || false;
  if (programParam) {
    params.program = programParam;
  }

  return params;
};
